import client from "./client";

export async function loadLoginFlow(inputs: Record<string, unknown>) {
    const response = await client.post("/login/load", inputs);

    return response.data;
}

export async function sendLoginLink(inputs: Record<string, unknown>) {
    const response = await client.post("/login-link/send", inputs);

    return response.data;
}
